export const ENROLL_ANOTHER_PARTICIPANTS = {
    title: 'Enroll yourself and your other minor children or dependents',
    description: 'Parents or guardians can enroll more than one participant in their account. This can include yourself, your minor children and your dependents.'
  };